import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { ArrowNext, LoadingSvg } from "../../common/icons";

function StickyFooter({
  goNextStep,
  onMouseHover,
  onMouseLeave,
  languages,
  onSubmitAddressDetails,
  secondaryPersonalDetailsSubmit,
  onSubmitSecondaryAddressDetails,
  memberStatus,
  personalDetailsSubmit,
  declinedSecondaryMembership,
  confirmOrder,
  reviewLoading,
  isProcessing,
  checkBoxTerms,
  currentStep,
  products,
  secondaryProducts,
  storeMembershipData,
  checkBoxTermsQBR,
  QBRLoading,
  confirmValidateQBR,
  validateQbr,
}) {
  // Button Next disabled checker
  if (currentStep === 1 && products !== null) {
    var selectedProduct = products.filter((x) => x.isSelected === true);
  }

  // Button Next disabled checker
  // if(currentStep === 2 && secondaryProducts !== null) {
  //     var selectedSecondaryProduct = secondaryProducts.filter(x => x.isSelected === true);
  // }

  return (
    <>
      {currentStep !== 9 && (
        <div className="footer fixed bottom-0 left-0 w-full py-5 flex justify-center h-88 bg-white">
          <div className="holder-button w-full flex align-center justify-center px-2">
            {
              // Product Step Button
              currentStep === 1 ? (
                <button
                  type="submit"
                  onClick={() => storeMembershipData(1)}
                  className={clsx(
                    "btn inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                    {
                      "btn-blue": selectedProduct.length === 0 ? false : true,
                      "btn-gray-disabled":
                        selectedProduct.length === 0 ? true : false,
                    }
                  )}
                >
                  <span>
                    {languages.next ? languages.next : "Next"}{" "}
                    <ArrowNext className="icon-next" />
                  </span>
                </button>
              ) : // Secondary Membership
              // currentStep === 2 ? (
              //     selectedSecondaryProduct.length === 0 ? (
              //         <button
              //             type='button'
              //             onClick={declinedSecondaryMembership}
              //             className={clsx('btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out',
              //             {})}
              //         >
              //             <span>{languages.noThanks ? languages.noThanks : 'No thanks'} <ArrowNext className='icon-next'/></span>
              //         </button>
              //     ) :
              //     <button
              //         type='button'
              //         onClick={() => storeMembershipData(2)}
              //         className={clsx('btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out',
              //         {})}
              //     >
              //         <span>{languages.next ? languages.next : 'Next'} <ArrowNext className='icon-next'/></span>
              //     </button>
              // ) :
              //QBR Step Validate Button
              // currentStep === 3 ? (
              //     <button
              //         form         = "validate-qbr"
              //         type         ='button'
              //         onClick      = {checkBoxTermsQBR ? confirmValidateQBR : validateQbr}
              //         className={clsx('btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out',
              //         {
              //             'btn-blue' : checkBoxTermsQBR ? true : false,
              //             'btn-processing': QBRLoading
              //         })}>
              //         {
              //             QBRLoading ?
              //             <span> <LoadingSvg className="process" /> &nbsp; {languages.processing ? languages.processing : 'Processing'} </span> :
              //             <span> {languages.validate ? languages.validate : 'Validate'} <ArrowNext className='icon-next'/></span>
              //         }
              //     </button>
              // ) :
              // Personal Details Step Button
              currentStep === 2 ? (
                <button
                  form="personal-details"
                  onClick={personalDetailsSubmit}
                  type="button"
                  className={clsx(
                    "btn  inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                    {
                      "btn-blue": memberStatus,
                      "btn-gray-disabled": !memberStatus,
                    }
                  )}
                >
                  <span>
                    {languages.next ? languages.next : "Next"}{" "}
                    <ArrowNext className="icon-next" />
                  </span>
                </button>
              ) : // Address Details Step Button
              // currentStep === 5 ? (
              //     <button
              //         form="address-details"
              //         onClick={onSubmitAddressDetails}
              //         type='button'
              //         className='btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'
              //     >
              //         <span>{languages.next ? languages.next : 'Next'} <ArrowNext className='icon-next'/></span>
              //     </button>
              // ) :
              // Secondary Membership Personal Details
              // currentStep === 6 ? (
              //     <button
              //         form="secondary-personal-details"
              //         onClick={secondaryPersonalDetailsSubmit}
              //         type='button'
              //         className={clsx("btn  inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out", {
              //             'btn-blue': memberStatus,
              //             'btn-gray-disabled': !memberStatus
              //         }
              //     )}>
              //         <span>{languages.next ? languages.next : 'Next'} <ArrowNext className='icon-next'/></span>
              //     </button>
              // ) :
              // Secondary Membership Address details
              // currentStep === 7 ? (
              //     <button
              //         form="address-details"
              //         onClick={onSubmitSecondaryAddressDetails}
              //         type='button'
              //         className='btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'
              //     >
              //         <span>{languages.next ? languages.next : 'Next'} <ArrowNext className='icon-next'/></span>
              //     </button>
              // ) :
              // Review Details Step Button
              currentStep === 3 ? (
                <button
                  type="button"
                  onClick={checkBoxTerms ? confirmOrder : ""}
                  onMouseEnter={!checkBoxTerms ? onMouseHover : ""}
                  onMouseLeave={!checkBoxTerms ? onMouseLeave : ""}
                  className={clsx(
                    "btn inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                    {
                      "btn-blue": checkBoxTerms ? true : false,
                      "btn-gray-disabled-review": !checkBoxTerms,
                      "btn-processing": reviewLoading,
                    }
                  )}
                >
                  {reviewLoading ? (
                    <span>
                      {" "}
                      <LoadingSvg className="process" /> &nbsp;{" "}
                      {languages.processing
                        ? languages.processing
                        : "Processing"}{" "}
                    </span>
                  ) : (
                    <span>
                      {languages.confirm ? languages.confirm : "Confirm"}{" "}
                      <ArrowNext className="icon-next" />
                    </span>
                  )}
                </button>
              ) : // Review Details Step Button
              currentStep === 9 ? null : (
                <button
                  type="button"
                  form={currentStep === 1 ? "form-product" : ""}
                  onClick={goNextStep}
                  // disabled={membershipSelected === "" ? true : false}
                  className={clsx(
                    "btn inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out",
                    {
                      "btn-blue": isProcessing ? true : true,
                      // 'btn-gray-disabled': membershipSelected === "" ? true : false,
                      "btn-processing": isProcessing,
                    }
                  )}
                >
                  {isProcessing ? (
                    <span>
                      {languages.processing
                        ? languages.processing
                        : "Processing"}
                    </span>
                  ) : (
                    <span>
                      {languages.next ? languages.next : "Next"}{" "}
                      <ArrowNext className="icon-next" />
                    </span>
                  )}
                </button>
              )
            }
          </div>
        </div>
      )}
    </>
  );
}

export default StickyFooter;
